import { Navigate, useLocation } from 'react-router-dom';
import { TenantProvider } from '../contexts/TenantContext';
import { UserContext } from '../contexts/UserContext';
import { useAuthUser } from '../hooks/useQueries';
import { PORTAL_ADMIN_URL } from '../constants';

interface BusinessDataRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper for business data pages (customers, tire sets, etc.)
 * BLOCKS SuperAdmins (DSGVO compliance - no access to tenant business data)
 * Provides TenantProvider for regular users and tenant admins
 */
export function BusinessDataRoute({ children }: BusinessDataRouteProps) {
  const location = useLocation();
  const { data: user, isLoading, isError } = useAuthUser();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600"></div>
      </div>
    );
  }

  // Redirect to login if authentication failed or no user data
  if (isError || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // super_admin verwaltet TireVault nicht mehr selbst (siehe Memory
  // project_superadmin_portal_migration) — raus aus TireVault, rein ins Portal.
  if (user.role === 'super_admin') {
    window.location.href = PORTAL_ADMIN_URL;
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600"></div>
      </div>
    );
  }

  // Wrap children with UserContext and TenantProvider for tenant users
  return (
    <UserContext.Provider value={{ user }}>
      <TenantProvider>
        {children}
      </TenantProvider>
    </UserContext.Provider>
  );
}
